@use "sass:color";
@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

%halfWidth {
  width: 50%;
}

.jobsFormContainer {
  padding: variables.$std-padding-sm;
}

.jsonTextArea {
  @extend %halfWidth;

  margin-top: variables.$std-margin-xs;
}

.retryCheckbox,
.scheduleCheckbox {
  display: flex;

  input {
    margin-right: variables.$std-margin-xs;
  }
}

.dateTimePicker {
  @extend %halfWidth;
}

.dateTimeError {
  input[type="text"] {
    border: 3px solid variables.$theme-danger;
    border-radius: 4px;
  }

  input[type="text"]:focus {
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(233, 107, 102, 0.6);
  }
}

.submitButton {
  margin-top: variables.$std-margin-md;
}

.errorMessage {
  margin-top: variables.$std-margin-sm;
}

.successMessage {
  background-color: color.adjust(variables.$theme-success, $lightness: 30%);
  font-weight: bold;
  color: variables.$theme-success;
  padding: variables.$std-padding-sm;
  margin-top: variables.$std-margin-sm;
}

.jsonStatusError {
  font-weight: bold;
  color: variables.$theme-danger;
  margin-top: variables.$std-margin-sm;
}

.jsonStatusOk {
  font-weight: bold;
  color: variables.$theme-success;
  margin-top: variables.$std-margin-sm;
}

.backfillWarning {
  margin-top: variables.$std-margin-sm;
}
